import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import CountryView from "./CountryView";
import CustomerPaymentTimeView from "./CustomerPaymentTimeView";
import CustomerStoresView from "./CustomerStoresView";
import CustomersView from "./CustomersView";
import CustomerView from "./CustomerView";
import { FETCH_PRODUCT_SALES_REPORT } from "./graphql";
import ProductsView from "./ProductsView";
import SalesView from "./SalesView";
import WarehouseChartView from "./WarehouseChartView";

const ReportView = ({
  startYear,
  endYear,
  reportType,
  partnerId,
  currency,
  customerData,
}) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_SALES_REPORT, {
    variables: { startYear, endYear, partnerId, reportType, currency },
  });

  const parsedReport = data?.odooAbSalesReportProducts
    ? JSON.parse(data.odooAbSalesReportProducts)
    : {};
  const records = parsedReport.summary;

  console.log("parsedReport", parsedReport);

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <div className="grid grid-cols-12 gap-6">
      <div className="space-y-6 col-span-8">
        <SalesView
          startYear={startYear}
          endYear={endYear}
          records={records}
          currency={currency}
          customerData={customerData}
        />
        <ProductsView
          startYear={startYear}
          endYear={endYear}
          records={records}
        />
      </div>

      <div className="space-y-6 col-span-4">
        {customerData && <CustomerView data={customerData} />}

        {customerData && <CustomerStoresView data={customerData} />}

        {partnerId && (
          <CustomerPaymentTimeView
            partnerId={partnerId}
            startYear={startYear}
            endYear={endYear}
          />
        )}

        {!partnerId && (
          <CountryView countries={parsedReport.countries} currency={currency} />
        )}

        <div className="card">
          <h5>Warehouse</h5>
          <div className="mt-4">
            <WarehouseChartView warehouses={parsedReport.warehouses} />
          </div>
        </div>

        {reportType && <CustomersView customers={parsedReport.customers} />}
      </div>
    </div>
  );
};

export default ReportView;
